/** 写接口令牌（本机）——dual-entry 规则 9 / 10，#5004。
 *
 * 操作员把服务端 `KEEL_API_TOKEN` 的值填一次，只存本机浏览器；之后界面的写请求统一带上。
 * 这不是配置修改入口（服务端配置仍只读），也不回显令牌明文。
 */

import { useState } from "react";

import { Card, Note } from "../../components/Card";
import { Pill } from "../../components/Pill";
import { clearApiToken, readApiToken, writeApiToken } from "../../api/token";

export function TokenCard(): React.ReactNode {
  const [saved, setSaved] = useState<boolean>(() => readApiToken() !== null);
  const [draft, setDraft] = useState("");
  const [note, setNote] = useState<{ tone: "" | "bad"; text: string } | null>(null);
  return (
    <Card title="写接口令牌（本机）" sub="只存本浏览器 · 写请求带 Authorization: Bearer" actions={saved ? <Pill tone="ok">已设置</Pill> : <Pill tone="warn">未设置</Pill>}>
      <div className="fieldrow">
        <label className="f">
          <span>令牌</span>
          <input type="password" autoComplete="off" value={draft} placeholder={saved ? "已保存（不回显）；填新值即替换" : "向管理员索取 KEEL_API_TOKEN 的值"} onChange={(e) => setDraft(e.target.value)} />
        </label>
      </div>
      <button
        type="button"
        className="btn primary"
        disabled={!draft.trim()}
        onClick={() => {
          const ok = writeApiToken(draft);
          setDraft("");
          setSaved(readApiToken() !== null);
          setNote(ok ? { tone: "", text: "已保存到本机浏览器。" } : { tone: "bad", text: "浏览器禁止本地存储（隐私模式或站点数据被禁用），令牌没存上，写操作会被拒。" });
        }}
      >
        保存
      </button>{" "}
      <button
        type="button"
        className="btn"
        disabled={!saved}
        onClick={() => {
          clearApiToken();
          setSaved(readApiToken() !== null);
          setNote({ tone: "", text: "已清除本机令牌。" });
        }}
      >
        清除
      </button>
      {note ? <Note tone={note.tone}>{note.text}</Note> : null}
      <Note>只读页面与事件流不需要令牌；停机、放行、补跑等写操作缺令牌或令牌不符时服务端返回 401，界面提示「令牌缺失或无效，去设置屏填写」。令牌不随前端构建、不由服务端下发。</Note>
    </Card>
  );
}
